import { Types } from 'mongoose';

export type StringObjectId = unknown & Types.ObjectId;

export enum GENDERS {
  MALE = 'Male',
  FEMALE = 'Female',
  UNKNOWN = 'Unknown',
}

export enum MARTIAL_STATUS {
  SINGLE = 'Single',
  MARRIED = 'Married',
  DIVORCED = 'Divorced',
  WIDOW = 'Widow',
}

export enum FAMILY_STATUS {
  LIVING = 'LIVING',
  DECEASED = 'DECEASED',
  UNKNOWN = 'Unknown',
}

export enum DEATH_STATUS {
  ACCIDENT = 'ACC',
  NATURAL = 'NAT',
  SICKNESS = 'SICK',
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY',
}

export enum PAYMENT_METHOD {
  CASH = 'CASH',
  CHEQUE = 'CHEQUE',
  DEBIT_CREDIT_CARD = 'DIRCR',
  PAYMENT_LINK = 'PAYMENTLINK',
  STANDING_ORDER = 'STANDINGORDER',
}

export enum SYNC_DATA_TYPE {
  AGENT = 'AGENT',
  AGENT_2 = 'AGENT_2',
  BANK = 'BANK',
  BANK_BRANCH = 'BANK_BRANCH',
  ZONE = 'ZONE',
  REGION = 'REGION',
  BRANCH = 'BRANCH',
  REFERRER = 'REFERRER',
}
